import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  accessRequestSchema,
  accessRequestsInputSchema,
  accessRequestsOutputSchema,
  approveAccessRequestInputSchema,
  declineAccessRequestInputSchema,
  previewOrganizationInputSchema,
  previewOrganizationOutputSchema,
  requestAccessInputSchema,
} from "./access-requests.schemas.ts";

// Declared once. The process binds access and handlers; the client derives its hooks.
export const accessRequestsTrpcContract = defineTrpcContract("access-requests", {
  previewOrganization: query({
    input: previewOrganizationInputSchema,
    output: previewOrganizationOutputSchema,
  }),
  requestAccess: mutation({ input: requestAccessInputSchema, output: accessRequestSchema }),
  accessRequests: query({ input: accessRequestsInputSchema, output: accessRequestsOutputSchema }),
  approveAccessRequest: mutation({ input: approveAccessRequestInputSchema, output: accessRequestSchema }),
  declineAccessRequest: mutation({ input: declineAccessRequestInputSchema, output: accessRequestSchema }),
});
